import React from 'react';
import UploadIcon from 'src/common/utils/TableColumnIcons/UploadIcon';
import { UploadFileMinos } from 'src/pages/Files/UpaloadFileMinos';

export const ActionColumnUpload = (
	value,
	row,
	rowIndex,
	{ onUploadedFile, allFiles, uniques, setLoader }
) => {
	return (
		<>
			<UploadFileMinos
				control={
					<UploadIcon
						onClick="download"
						download="download"
						name={row.nombre}
						id={'BtnuploadMinos' + row.idEntidad + 'Adicional'}
						color="#808080"
						title="Nueva Version"
					/>
				}
				onUploaded={onUploadedFile}
				idEntidad={row.idEntidad}
				tipo={row.tipo}
				entidad={row.entidad}
				ruta={'Adicional/' + row.idEntidad + '/'}
				title={'Adicional'}
				setOpen={setLoader}
				adicional={true}
				allFiles={allFiles}
				uniques={uniques}
			/>
		</>
	);
};
